import { jsx } from "react/jsx-runtime";
import { isCallState } from "./types.js";
function ProductHighlightPart({
  part,
  allParts
}) {
  if (isCallState(part.state)) {
    return /* @__PURE__ */ jsx("div", { className: "concierge-loading", children: "Loading product..." });
  }
  if (allParts.some((p) => p.type === "data-product-highlight")) return null;
  return null;
}
export {
  ProductHighlightPart
};
//# sourceMappingURL=ProductHighlightPart.js.map
